import React, { useState, useEffect } from 'react';
import { useGetUser, useSetUser } from '../../context/userContext';
import editUser from '../../api/editUser';

const Language = () => {
  const user = useGetUser();
  const setUser = useSetUser();
  const [edit, setEdit] = useState(false);
  const [userCopy, setUserCopy] = useState(user);

  useEffect(() => {
    setUserCopy(user);
  }, [user]);

  return (
    <div className="row mycard mb-5">
      <div className="col col-12">
        {edit ? <EditInfo userCopy={userCopy} setUserCopy={setUserCopy} user={user} setUser={setUser} setEdit={setEdit} /> : <Info userCopy={userCopy} setEdit={setEdit} />}
      </div>
    </div>
  );
};

export default Language;

const Info = ({ userCopy, setEdit }) => {
  return (
    <>
      <h2 className="heading">
        <span>Language</span>
        <button className="btn btn-sm profile-btn" onClick={() => setEdit(true)}>
          <i className="bi bi-pencil-fill"></i> Edit
        </button>
      </h2>
      <div className="content mx-5">
        <div className="main">
          {userCopy.languages?.length === 0 && (
            <div className="col col-12">
              <span className="lead">No details has been provided yet.</span>
            </div>
          )}
          {userCopy.languages &&
            userCopy.languages.map((el) => {
              let w = 10;
              switch (el.level) {
                case 'beginner':
                  w = 5;
                  break;
                case 'elementary':
                  w = 20;
                  break;
                case 'intermediate':
                  w = 40;
                  break;
                case 'upper intermediate':
                  w = 60;
                  break;
                case 'advanced':
                  w = 80;
                  break;
                case 'proficient':
                  w = 100;
                  break;
                default:
                  w = 0;
                  break;
              }

              return (
                <div className="row py-3" key={el._id}>
                  <div className="col col-12 col-md-4 col-lg-4 col-xl-3">
                    <span className="lang">{el.name}</span>
                  </div>
                  <div className="col col-12 col-md-4 col-lg-4 col-xl-6 d-none d-md-block">
                    <div className="progress" style={{ marginBottom: '-3px', marginTop: '3px' }}>
                      <div className={`progress-bar w-${w}`} role="progressbar" aria-valuenow={w} aria-valuemin={0} aria-valuemax={100} />
                    </div>
                  </div>
                  <div className="col col-12 col-md-4 col-lg-4 col-xl-3">{el.level}</div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

const EditInfo = ({ userCopy, setUserCopy, user, setUser, setEdit }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    editUser(userCopy, setUser);
    setEdit(false);
  };

  const handleCancel = () => {
    setUserCopy(user);
    setEdit(false);
  };

  const handleNameChange = (e, index) => {
    setUserCopy((prev) => {
      const arr = prev.languages;
      arr[index].name = e.target.value;
      return { ...prev, languages: arr };
    });
  };

  const handleLevelChange = (e, index) => {
    setUserCopy((prev) => {
      const arr = prev.languages;
      arr[index].level = e.target.value;
      return { ...prev, languages: arr };
    });
  };

  const handleAddLanguage = () => {
    setUserCopy((prev) => {
      const arr = [...prev.languages];
      arr.push({ id: Date.now(), city: '', country: '' });
      return { ...prev, languages: arr };
    });
  };

  const handleRemoveLanguage = (_id, id) => {
    if (_id) {
      setUserCopy((prev) => {
        const arr = prev.languages;
        const filtered = arr.filter((el) => el._id !== _id);
        return { ...prev, languages: filtered };
      });
    } else {
      setUserCopy((prev) => {
        const arr = prev.languages;
        const filtered = arr.filter((el) => el.id !== id);
        return { ...prev, languages: filtered };
      });
    }
  };

  return (
    <>
      <h2 className="heading">
        Language
        <span></span>
      </h2>
      <div className="content mx-5">
        <div className="main">
          <form className="row g-3" onSubmit={(e) => handleSubmit(e)}>
            <div className="col-12 col-md-12">
              {userCopy.languages &&
                userCopy.languages.map((el, index) => (
                  <div className="row mb-3" key={index}>
                    <div className="col col-md-5">
                      <input type="text" className="form-control" placeholder="language" value={el.name || ''} onChange={(e) => handleNameChange(e, index)} />
                    </div>
                    <div className="col col-md-5">
                      <select className="form-select" value={el.level || ''} placeholder="aaa" onChange={(e) => handleLevelChange(e, index)}>
                        <option value="">choose level...</option>
                        <option value="beginner">beginner</option>
                        <option value="elementary">elementary</option>
                        <option value="intermediate">intermediate</option>
                        <option value="upper intermediate">upper intermediate</option>
                        <option value="advanced">advanced</option>
                        <option value="proficient">proficient</option>
                      </select>
                    </div>

                    <div className="col col-md-2 text-end">
                      <button type="button" className="btn btn-link del" onClick={() => handleRemoveLanguage(el._id, el.id)}>
                        <i className="bi bi-trash"></i>
                      </button>
                    </div>
                  </div>
                ))}
              {userCopy.languages?.length < 5 && (
                <div>
                  <button type="button" className="btn btn-link btn-sm" onClick={handleAddLanguage}>
                    <i className="bi bi-plus text-danger"></i> Add language
                  </button>
                </div>
              )}
            </div>

            <div className="col-12 text-end">
              <button type="button" className="btn profile-btn inver mb-1" onClick={handleCancel}>
                Cancel
              </button>
              <button type="submit" className="btn profile-btn mb-1 ms-3">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
